'use client';

import { useSearchParams } from 'next/navigation';

import { Growth } from './Growth';
import { Project } from './Project';
import { Today } from './Today';

import '@/app/_styles/canon-hub.css';

/**
 * Hub body — switches Today / Growth / Project on `?view=`. Default = Today.
 * The subtabs themselves live in the AppShell sub-bar (`HubSubtabs`).
 */
export function HubClient() {
  const view = useSearchParams()?.get('view') ?? 'today';
  if (view === 'growth') return <Growth />;
  if (view === 'project') return <Project />;
  return <Today />;
}
